import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ArrowBackRounded } from '@mui/icons-material';
import { layoutIconButtonRadius } from '../../theme/colors';

const BACK_SLOT = 40;

export const PageBackButton = ({ onClick }) => (
  <IconButton
    data-no-shadow="true"
    aria-label="Voltar"
    onClick={onClick}
    sx={{
      color: 'text.primary',
      borderRadius: layoutIconButtonRadius,
      width: BACK_SLOT,
      height: BACK_SLOT,
      p: 1,
      m: 0,
      ml: -1,
      flexShrink: 0,
      overflow: 'hidden',
      '& .MuiTouchRipple-root': {
        borderRadius: 'inherit',
      },
      '& .MuiTouchRipple-child': {
        borderRadius: layoutIconButtonRadius,
      },
    }}
  >
    <ArrowBackRounded />
  </IconButton>
);

const PageHeader = ({ title, onBack }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      width: '100%',
      minHeight: BACK_SLOT,
    }}
  >
    {onBack ? (
      <PageBackButton onClick={onBack} />
    ) : (
      <Box sx={{ width: BACK_SLOT, height: BACK_SLOT, ml: -1, flexShrink: 0 }} aria-hidden />
    )}

    <Typography
      variant="pageTitle"
      sx={{
        flex: 1,
        textAlign: 'center',
        minWidth: 0,
        px: 0.5,
      }}
    >
      {title}
    </Typography>

    <Box sx={{ width: BACK_SLOT, height: BACK_SLOT, mr: -1, flexShrink: 0 }} aria-hidden />
  </Box>
);

export default PageHeader;
